import pathBuilder from "./pathBuilder";

export const BASE_V_MANAGE_URL = "/#/app/monitor2";
export const BASE_TENANT_URL = "/app/monitor2";
export const SETTINGS_URL = "/#/app/administration/settings";
export const LICENSE_PAGE_URL = "/#/app/administration/licenseManager/overview";
export const PROFILE_URL = "/#/app/profile";
export const API_VERSION = "v4";
export const BASE_API_URL =
  process.env.REACT_APP_BASE_API_URL || "/analytics/api/";
export const BASE_V4_API_URL = `${BASE_API_URL}${API_VERSION}/dataservice/`;
const PUBLIC_URL = process.env.PUBLIC_URL || "/analytics/v4/";
export const BASE_URL = PUBLIC_URL === "/" ? "" : PUBLIC_URL.replace(/\/+$/, "");
export const BASE_REPORT_URL = "/api/dataservice/reporting/";

const BASE_METASERVICE_URL = `${BASE_API_URL}metaservice/`;
const BASE_METASERVICE_URLV4 = `${BASE_API_URL}v4/metaservice/`;

export const CRSF_TOKEN_URL = `${BASE_API_URL}csrf`; //api to get crsf token
export const SMART_ACC_URL = `${BASE_METASERVICE_URL}smartAccount`; //api to get smart account data
export const SMART_ACC_FILTER_URL = `${BASE_METASERVICE_URL}smartAccount/filter`; // api to get support role domain accounts list
export const SMART_ACC_INFO_URL = `${BASE_METASERVICE_URL}smartAccount/info?`; // api to get domain account info

//overview tab
export const TOP_DEVICE_URL = `${BASE_V4_API_URL}aggregate/devices`; //api to get device dashlet
export const SUMMARY_DATA_URL = pathBuilder("custom/overview/summary"); //api to get filter view widgets
export const TOP_USERS_URL = `${BASE_V4_API_URL}aggregate/clients`; //api to get users dashlet
export const NOTIFICATION_INSIGHTS = `${BASE_API_URL}${API_VERSION}/notification/insight/list`; //api to get insights list

export const TOP_USERS_URL_REPORT = `${BASE_V4_API_URL}aggregate/topclients`; //api to get users dashlet

//alto widget landing page
export const ALTO_CLASS_APP_LIST = pathBuilder("custom/alto/lists/applications"); // api get apps class list for alto widget in overview page
export const ALTO_RECO_METRICS = pathBuilder("custom/alto/recommendations/metrics/endpoints"); // api to get recommendations metrics
export const ALTO_ENDPOINT_SITE_ID = pathBuilder("custom/alto/lists/endpoints"); // api to get lists endpoints
export const ALTO_ENDPOINT_ACTION = pathBuilder("custom/alto/recommendation/actions"); // api to get list of actions
export const ALTO_RECOM_METRICS_PATHS = pathBuilder("custom/alto/recommendations/metrics/paths"); // api to get list of paths
export const ALTO_PATHS_DETAILS = pathBuilder("custom/alto/network/paths/detailed"); // api to get list of paths details
export const ALTO_PATH_METRICS = pathBuilder("custom/alto/network/metrics/path"); // api to get path metcis
export const ALTO_NETWORK_PATHS = pathBuilder("custom/alto/network/paths"); // api to get list of paths
export const ALTO_ACTIONS_APPLY = `${BASE_API_URL}alto/set_wani_actionlist`; // api to apply actions

export const FILTERVIEW_APPS_URL = pathBuilder("custom/overview/applications/summary"); //api to get filter view for apps widget

export const TOP_APP_DONUT_URL = pathBuilder("custom/overview/applications/vqoe_donut"); //api to get application donut chart
export const TOP_APP_STACKED_URL = pathBuilder("custom/overview/applications/vqoe_stacked"); //api to get application stacked chart

//application tab
export const TABLE_CUSTOMLIST_URL = `${BASE_API_URL}${API_VERSION}/dataservice/aggregate/applications`; // api to get table custom list or get usage details for app experience
export const QOE_DISTRIBUTION_URL = pathBuilder("custom/applications/qoe_distribution/application_classes"); //api to get qoe distribution
export const TREND_APP_BY_RISE_OR_DROP_URL = pathBuilder("custom/applications/trend_applications/"); //api to get trend app by rise or drop
export const APPLICATION_TABLE_LIST_URL = `${BASE_API_URL}${API_VERSION}/dataservice/aggregate/applications/table`;// api to get table custom list or get usage details for app experience

//app360 tab
export const APP360_TOP_USERS_URL = pathBuilder("custom/app360/top_users/default"); //api to get  app 360 app users
export const OP_MAP_BY_SITES_URL = `${BASE_API_URL}${API_VERSION}/dataservice/aggregate/app360/sites`;//api to get map sites

//sidebar trend analysis
export const APP_COUNT_BY_QOE_URL = `${BASE_V4_API_URL}time_series/applications/app_count_by_qoe`;  //api to get app count by qoe in sidebar trend analysis
export const APP_BY_BANDWIDTH_URL = `${BASE_V4_API_URL}time_series/applications/usage_summary`; //api to get total app by bandwidth in sidebar trend analysis
export const TOP_APPS_BY_BANDWIDTH_URL = `${BASE_V4_API_URL}time_series/applications/bandwidth`; //api to get app usage data in sidebar trend analysis
export const AGGREGATE_DATA_URL = `${BASE_V4_API_URL}time_series/applications/qoe`; //api to get aggregate data
export const AGGREGATE_DATA_WITH_WIDGET_KEY_URL = pathBuilder("generic/application_performance_view/"); //api to get aggregate data with widget key
export const APP360_APPFLOW_URL = pathBuilder("custom/app360/appflow/tunnel_list"); //Custom API to get Appflow tunnel_list data

//site dropdown widget
export const SITES_URL = `${BASE_V4_API_URL}site_info`; //api to get sites
export const APP_PERF_URL = `${BASE_V4_API_URL}aggregate/applications`;

//sites tab
export const SITES_TABLE_AVAILABILITY_TIMEFRAME = `${BASE_V4_API_URL}aggregate/sites`; //api to get sites in timeframe
export const SITES_TABLE_URL = `${BASE_V4_API_URL}aggregate/sites/table`;

//report feature, all applications headless browser
export const QOE_USAGE_DETAILS_URL = pathBuilder("custom/applications/accordion/qoe_usage_summary"); //api to get qoe usage in report and details for app experience
export const GENERATE_EDIT_REPORT_URL = `${BASE_METASERVICE_URL}report`; //api to generate and edit the report
export const ALL_TEMPLATES_URL = `${BASE_METASERVICE_URL}report_template`; //api to get all templates for different types of reports
export const DELETE_OR_GET_REPORT_FROM_ID_URL = `${BASE_METASERVICE_URL}report/report_uuid=`; //api to get either delete or get the report info based on uuid
export const ALL_REPORTS_URL = `${BASE_METASERVICE_URL}report/overlay_id=`; //api to get all reports that were generated
export const REPORT_DATA_URL = pathBuilder("report/:id"); //api to get report data for all applications headless browser
export const REPORTS_URL = `${BASE_URL}/reports`;
export const REPORTS_URL_HOME = `${BASE_URL}/reports#generated-reports`;

//pdf paths
export const REPORT_EXECUTIVE = `${BASE_REPORT_URL}:id/executive_summary`;
export const REPORT_SITES = `${BASE_REPORT_URL}:id/site_summary`;
export const REPORT_APPS = `${BASE_REPORT_URL}:id/application_summary`;
export const REPORT_APP360 = `${BASE_REPORT_URL}:id/application_summary/:appName`;

// Define/Edit/View IDP Endpoints
export const DEFINE_IDP_OIDC = `${BASE_METASERVICE_URL}defineIdp/oidc`;
export const EDIT_IDP_OIDC = `${BASE_METASERVICE_URL}editIdp/oidc`;
export const DEFINE_IDP_SAML = `${BASE_METASERVICE_URL}defineIdp/saml`;
export const EDIT_IDP_SAML = `${BASE_METASERVICE_URL}editIdp/saml`;
export const UPLOAD_SAML = `${BASE_METASERVICE_URL}idpMetadata/saml`;
export const VIEW_IDP_OIDC = `${BASE_METASERVICE_URL}viewIdp/oidc`;
export const VIEW_IDP_SAML = `${BASE_METASERVICE_URL}viewIdp/saml`;
export const DELETE_IDP = `${BASE_METASERVICE_URL}deleteIdp`;
export const UPDATE_ACCOUNT = `${BASE_METASERVICE_URL}overlay_rbac`;

// Logout
export const LOGOUT = `${BASE_API_URL}logout`;

// Okta webfinger
export const OKTAWEBFINGER = "/.well-known/webfinger";

//WANI Onboarding
export const ONBOARDING_STATUS = `${BASE_API_URL}wan-insights-service/onboarding/status`;
export const ONBOARDING_ACTIVATE = `${BASE_API_URL}wan-insights-service/onboarding/activate`;

// fabric license
export const fabricLicense = `${BASE_METASERVICE_URLV4}overlay/features`;

// circuits
export const circuitUrls = {
  singleTable: `${BASE_V4_API_URL}aggregate/circuits`,
  trendAvailability: `${BASE_V4_API_URL}time_series/circuits/nw_availability`,
  bandwidthAvg: `${BASE_V4_API_URL}time_series/circuits/bandwidth`,
  singleCircuitsV4Table: `${BASE_V4_API_URL}aggregate/circuits/table`
};

// circuit 360
export const c360Urls = {
  slaReportLLJ: `${BASE_V4_API_URL}time_series/circuits/sla`
};

// AD @ Single Site
export const AD_SINGLE_SITE_URL = `${BASE_API_URL}${API_VERSION}/dataservice/time_series/ad/overlay/info`; // api for AD @ Single Site
export const AD_SINGLE_SITE_TABLE_URL = `${BASE_API_URL}${API_VERSION}/dataservice/time_series/ad/sites`; // api for AD @ Single Site table
export const AD_SINGLE_SITE_HEATMAP_URL = `${BASE_API_URL}${API_VERSION}/dataservice/time_series/ad/sites`; // api for AD @ Single Site heatmap
export const AD_SINGLE_SITE_HOURLY_TABLE_URL = `${BASE_API_URL}${API_VERSION}/dataservice/time_series/ad/all_tunnel_summary`; // api for AD @ Single Site heatmap table
export const AD_SINGLE_SITE_TREND_CHARTS_URL = `${BASE_API_URL}${API_VERSION}/dataservice/time_series/ad/all_trend`; // api for AD @ Single Site tunnel trend charts

// USAGE Based AD
export const USAGE_BASED_AD_USAGE_CIRCUIT = `${BASE_API_URL}${API_VERSION}/dataservice/time_series/ad_usage/overlay_trend`; // api for Usage Based AD
export const AD_SUMMARY_CIRCUIT_TABLE_URL = `${BASE_API_URL}${API_VERSION}/dataservice/time_series/ad_usage/circuits_table`; // api for Usage Based AD circuits_table
export const AD_CELLULAR_INTERFACE_USAGE_URL = `${BASE_API_URL}${API_VERSION}/dataservice/time_series/ad_usage/circuits_usage_trend`; // api for Usage Based AD cellular interface usage trend
export const AD_AVAILABILITY_TABLE_URL = `${BASE_API_URL}${API_VERSION}/dataservice/time_series/ad_usage/site_circuits_table`; // api for Usage Based AD availability table
export const AD_CIRCUIT_TREND_AVAIL_CHART_URL = `${BASE_API_URL}${API_VERSION}/dataservice/time_series/circuits/nw_availability`; // api for Usage Based AD network availability table
export const AD_APP_TABLE_URL = `${BASE_API_URL}${API_VERSION}/dataservice/time_series/ad_usage/circuit_applications_table`; // api for Usage Based AD app table
export const AD_APP_CHART_URL = `${BASE_API_URL}${API_VERSION}/dataservice/time_series/circuits/usage_by_applications`; // api for Usage Based AD app chart
export const AD_TOP_CLIENTS_URL = `${BASE_API_URL}${API_VERSION}/dataservice/time_series/ad_usage/circuit_clients_table`; // api for Usage Based AD top clients

//Banner Notification
export const PRE_LOGIN_NOTIFICATION_URL = `${BASE_API_URL}notificationservice/system`; //api to get banner notification for pre-login
export const POST_LOGIN_NOTIFICATION_URL = `${BASE_API_URL}notificationservice/tenant`; // api to get post-login notification
export const UPDATE_NOTIFICATION_URL = `${BASE_API_URL}notificationservice/state`; // api to update post-login notification

//vManage apis
export const WAFFLE_STATE = "/dataservice/settings/configuration/waffle";// api to get waffle state in the top right header
export const NAVIGATION_PANEL_URL = "/dataservice/client/navigation"; // api to get side panel tabs list
export const DIAGNOSTIC_STAGING_URL = "/dataservice/diagnostic/center/staging"; // api to check System360 staging access
export const TASK_URL = "/dataservice/client/activity/summary";
export const DEVICE_STATUS_URL = "/#/app/device/status"; // route to vManage device status page
export const COMPLIANCE_URL = "/dataservice/msla/licenses/compliance";
export const NOTIFICATION_URL = "/dataservice/alarms/topn";
export const ALARM_COUNT_URL = "/dataservice/alarms/count";
export const LOGOUT_vMANAGE = `/logout?nocache=${Date.now()}&reason=logout`;
export const TENANT_URL = "/dataservice/tenant";
export const V_MANAGE_TOKEN_URL = "/dataservice/client/token";
export const AI_FEATURE_URL = "/dataservice/aiassistant/feature";
export const AI_SESSION_URL = "/dataservice/aiassistant/dsm/session";
export const AI_SUGGESTION_URL = "/dataservice/aiassistant/dsm/suggestion";
export const AI_DIALOG_URL = "/dataservice/aiassistant/dsm/dialog";
export const FEEDBACK_URL = "/dataservice/aiassistant/dsm/feedback";
export const ABOUT_URL = "/dataservice/client/about";
export const SESSION_ALIVE_URL = "/dataservice/client/event/poll/events";
export const CLOUD_SERVICES_URL = "/dataservice/settings/configuration/cloudservices";
export const getVSessionURL = (key) => `/dataservice/tenant/${key}/vsessionid`;
export const getDeviceStatusURL = (tenantId) => tenantId ? `/#/${tenantId}/app/device/status` : DEVICE_STATUS_URL;
export const WANI_NOTIFICATIONS_URL = `/dataservice/wani/recommendations`;
export const I18N_JSON_FILE_URL = `${location.origin}/app/json/i18n/en_US.json`; // api to get i18n data
export const V_MANAGE_CLIENT_DATA_URL = "/dataservice/client/server"; // api to get vManage client data
export const V_MANAGE_USER_GROUP_URL = "/dataservice/admin/usergroup";
export const V_MANAGE_USER_ROLES_URL = "/dataservice/client/user/roles";

//vAnalytics apis for ai assistant
export const AI_ASSISTANT_DIALOG_URL = `${BASE_API_URL}${API_VERSION}/dataservice/aiassistant/dsm/dialog`;
export const AI_ASSISTANT_FEEDBACK_URL = `${BASE_API_URL}${API_VERSION}/dataservice/aiassistant/dsm/feedback`;
export const AI_ASSISTANT_EXPLAIN_URL = `${BASE_API_URL}${API_VERSION}/dataservice/aiassistant/dsm/explain`;
export const AI_ASSISTANT_URL = `${BASE_API_URL}${API_VERSION}/dataservice/aiassistant/dsm/dialog`;
export const AI_VA_SESSION_URL = `${BASE_API_URL}${API_VERSION}/dataservice/aiassistant/dsm/session`;

export const getFirewallUrl = `${BASE_API_URL}${API_VERSION}/dataservice/devices_config`; // api to get firewall data
